import { forwardRef } from 'react';
import { AllieTimeGrid } from './TimeGrid';
import { TimeGridTvProps } from './TimeGridTv.types';
import { TvGridWrapper } from './TimeGridTv.styles';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const EMPTY_POPOVER_LABELS = {
  labels: {
    withoutMotive: '',
    addMotive: '',
    editMotive: '',
    addTechnicalStop: '',
    deleteStop: '',
  },
};

export const AllieTimeGridTv = forwardRef<HTMLDivElement, TimeGridTvProps>(
  (
    {
      data,
      yAxisLabels,
      dataUnits,
      startAtProductions,
      timezone,
      showTimeTicker = true,
      heightRow = 50,
      heightMinutesRow = 40,
      redThreshold,
      greenThreshold,
    },
    ref,
  ) => (
    <TvGridWrapper ref={ref}>
      <AllieTimeGrid
        data={data}
        yAxisLabels={yAxisLabels}
        dataUnits={{
          label: dataUnits.label,
          rateLabel: dataUnits.rateLabel,
          units: dataUnits.units,
          unitLabel: '',
          showArrow: false,
        }}
        timezone={timezone}
        shouldScrollIntoView={false}
        showTimeTicker={showTimeTicker}
        isCurrentShift
        heightRow={heightRow}
        heightMinutesRow={heightMinutesRow}
        showAddTechnicalStopMenu={false}
        onNewStop={noop}
        onClickOpenModalReason={noop}
        onClickAddTechnicalStop={noop}
        labelsPopoverAddStop={EMPTY_POPOVER_LABELS}
        renderPopoverInfoProduction={() => <></>}
        renderAssignReasonForm={() => undefined}
        startAtProductions={startAtProductions}
        redThreshold={redThreshold}
        greenThreshold={greenThreshold}
      />
    </TvGridWrapper>
  ),
);

AllieTimeGridTv.displayName = 'AllieTimeGridTv';
